// frontend/src/pages/DossiersPage.js
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import api from '../services/api';

const DossiersPage = () => {
  const { t } = useTranslation();
  const [orphelins, setOrphelins] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOrphelins = async () => {
      try {
        const response = await api.get('/orphelins', { params: { all: true } });
        setOrphelins(response.data);
      } catch (error) {
        console.error('Erreur lors du chargement des orphelins:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchOrphelins();
  }, []);

  if (loading) {
    return <div className="p-8 text-center">{t('files.loading')}</div>;
  }

  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold mb-6">{t('files.title')}</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {orphelins.map((orphelin) => (
          <Link
            key={orphelin.id}
            to={`/orphelin/${orphelin.id}`}
            className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow"
          >
            <h2 className="text-xl font-semibold mb-2">
              {orphelin.prenom} {orphelin.nom}
            </h2>
            <p className="text-gray-600 mb-2">
              {t('files.bornOn')}: {new Date(orphelin.date_naissance).toLocaleDateString('fr-FR')}
            </p>
            <div className="text-blue-600 mt-4">{t('files.viewFile')}</div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default DossiersPage;